import { FC, useEffect, useState } from 'react';
import axios from 'axios';
import { COMPANY_LOOKUP_HOST, GOOGLE_TAG_MANAGER_ID, PDF_GENERATION_HOST } from '../../constants';
import { useHistory, useLocation } from 'react-router';
import { connect, useDispatch, useSelector } from 'react-redux';
import {
  editorSlice,
  selectFormStatePayload,
  selectOrderPassword,
} from '../editor/editorSlice';
import { getAllUrlParams } from '../../utils/url';
import DocumentDownloadPage from './DocumentDownload.page';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import TagManager from 'react-gtm-module'
import { Button } from 'antd';
import { isAdmin } from '../../utils/AuthorizationValidation';
import { SaveFeedbackAction } from '../../app/ActionsImpl';

interface Props {
  user: any
}

const DocumentDownloadContainer: FC<Props> = ({ user }) => {
  const history = useHistory();
  const formState = useSelector(selectFormStatePayload);
  const [postError, setPostError] = useState<string | null>(null);


  useEffect(() => {
    let search = window.location.search
    let params: any = getAllUrlParams()
    if (params.adm === undefined && isAdmin()) {
      if (search.indexOf("?") !== -1) {
        search += '&adm=01'
      } else {
        search += '?adm=01'
      }
      if (history) {
        history.push({
          pathname: window.location.pathname,
          search: search
        })
      }
    }
  }, [user])

  const createDocs = async (params: any) => {
    try {
      await axios
        .post(
          `${PDF_GENERATION_HOST}/order/post`,
          {
            flow_id: params.flow_id,
            formState,
            formData: params.formData,
            steps: getAllUrlParams(document.location.href),
            docs: params.steps,
            price: params.price,
            shortId: params.shortId,
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          },
        )
        .then(async (res) => {
          window.location.href = `/user-profile?order=${res.data.id}`
        });
    } catch (error: any) {
      console.error("Chyba pri POST /order:", error);
      setPostError(error.message || "Nepodarilo sa vytvoriť objednávku.");
    }
  };

  useEffect(() => {
    if (formState) {
      createDocs(history.location.state);
    }
  }, []);


  return (
    <DocumentDownloadPage postError={postError} />
  );
};

const mapStateToProps = ({ appState }: any) => ({
  user: appState.cognitoUser
});

export default connect(mapStateToProps)(DocumentDownloadContainer);
